<template>
	<div
		class="flex items-center justify-center w-5 h-5 rounded-full"
		:class="icon.bgClass"
	>
		<AppIcon :name="icon.name" :class="icon.class" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AppIcon from "@/components/AppIcon.vue";

const props = defineProps<{
	status: "success" | "failed" | "pending";
}>();

const icon = computed(() => {
	switch (props.status) {
		case "success":
			return {
				name: "check",
				bgClass: "bg-green-100",
				class: "text-green-600",
			};
		case "failed":
			return {
				name: "close",
				bgClass: "bg-red-100",
				class: "text-red-600",
			};
		case "pending":
		default:
			return {
				name: "schedule",
				bgClass: "bg-blue-100",
				class: "text-blue-600",
			};
	}
});
</script>
